var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-breadcrumb"}},[_c('ul',{staticClass:"breadcrumb-list"},_vm._l((_vm.crumbItems),function(item){return _c('li',{key:item},[_vm._v(_vm._s(item))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }